import React from 'react';
import './Footer.css';
import { FaWhatsapp, FaFacebookF, FaInstagram, FaTwitter, FaFlickr } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { routeMap } from '../../../config/routes';

import mainLogo from "../../../assets/villasflamingos-logo.svg";
import awardLonelyPlanet from '../../../assets/LonelyPlanet-logo.png';
import awardTraveler from '../../../assets/Traveler-logo.png';
import awardFoodTravel from '../../../assets/FoodTravel-logo.png';
import awardTripAdvisor from '../../../assets/TripAdvisorAbout.png';
import awardVerified from '../../../assets/Verified-logo.png';
import awardLush from '../../../assets/Lush-logo.png';

const Footer: React.FC = () => {
  // 1. Hook vacío
  const { i18n } = useTranslation();
  const currentLang = i18n.language.split('-')[0];

  return (
    <footer className="site-footer">
      <div className="footer-content">
        {/* Columna izquierda: logo + redes sociales */}
        <div className="footer-left">
          <img src={mainLogo} alt="Villas Flamingos" className="footer-logo" />
          <div className="social-icons">
            <a target='_blank' rel='noopener noreferrer' href="https://api.whatsapp.com/send/?phone=5219841250102&text&type=phone_number&app_absent=0" aria-label="WhatsApp"><FaWhatsapp /></a>
            <a target='_blank' rel='noopener noreferrer' href="https://www.facebook.com/VillasFlamingosHolbox" aria-label="Facebook"><FaFacebookF /></a>
            <a target='_blank' rel='noopener noreferrer' href="https://www.instagram.com/flamingosholbox/" aria-label="Instagram"><FaInstagram /></a>
            <a target='_blank' rel='noopener noreferrer' href="https://x.com/flamingosholbox" aria-label="Twitter"><FaTwitter /></a>
            <a target='_blank' rel='noopener noreferrer' href="https://www.flickr.com/photos/villasflamingosholbox/" aria-label="Flickr"><FaFlickr /></a>
          </div>
        </div>

        {/* Columna derecha: contacto, logos, pie legal */}
        <div className="footer-right">
          <div className="footer-contact">
            <a href="tel:+529848752167" className="footer-phone">+52-984-875-2167</a>
            <div className="address-block">

              <p><Trans i18nKey="footer:address" /></p>
            </div>
            <a href="mailto:info@villasflamingos.com" className="footer-email">info@villasflamingos.com</a>
          </div>

          <div className="footer-awards">
            <img src={awardLonelyPlanet} alt="Lonely Planet" />
            <img src={awardTraveler} alt="Traveler" />
            <img src={awardFoodTravel} alt="Food & Travel" />
            <img src={awardTripAdvisor} alt="TripAdvisor" />
            <img src={awardVerified} alt="Verified" />
            <img src={awardLush} alt="Lush" />
          </div>

          <div className="footer-bottom">
            <div className='footer-bottom-left'>
              <p>
                VILLAS FLAMINGOS 2025 • <a href="https://www.villasflamingos.com/files/Vilavid-VF-aviso-de-privacidad.pdf" target="_blank" rel="noopener noreferrer"><Trans i18nKey="footer:privacyPolicy" /></a>
              </p>
            </div>
            <div className="footer-bottom-right">
              <p>
                <Link to={`/${currentLang}/${routeMap.employe[currentLang as 'en' | 'es']}`}>
                  <Trans i18nKey="footer:employment" />
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;